import { render, staticRenderFns } from "./breadCrumbCas.vue?vue&type=template&id=16b435b4&scoped=true"
import script from "./breadCrumbCas.vue?vue&type=script&lang=js"
export * from "./breadCrumbCas.vue?vue&type=script&lang=js"
import style0 from "./breadCrumbCas.vue?vue&type=style&index=0&id=16b435b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b435b4",
  null
  
)

export default component.exports